
import { defineComponent, nextTick, onMounted, reactive, toRefs } from "vue";
import { StateType } from "./originPlasticSource";
import { getPlasticSourceList } from "../../../../api/production";
import Throttle from "@/utils/throttle";
import { Router, useRouter } from "vue-router";
// import PreviewVideo from "@/components/previewVideo/previewVideo.vue";
import { QI_LIU_BASE_URL } from "@/utils/util";
const TencentMap = (window as any).TMap;
let throttle: Throttle;
const stateData = {
  dataList: [],
  weatherList: [],
  id: "",
  pid: "",
  router: {},
  page: 1,
  videoUrl: "",
  // previewVideo: false,
  qiniuUrl: QI_LIU_BASE_URL,
  countList: [] as any,
};
export default defineComponent({
  // components: {
  //   PreviewVideo,
  // },
  props: ["dataId"],
  setup(prop) {
    const states = reactive<StateType>(stateData);
    states.router = useRouter();
    const router = useRouter();

    const { getPlasticSourceData } = useDatas(states);
    onMounted(() => {
      states.id = prop.dataId;
      states.dataList = [];
      states.weatherList = [];
      getPlasticSourceData();
      throttle = new Throttle(500, () => {
        states.page++;
        getPlasticSourceData();
      });
    });
    return {
      ...toRefs(states),
      ...useEvent(states, router),
    };
  },
});
// 获取数据相关hook
const useDatas = (state: StateType) => {
  const getPlasticSourceData = async () => {
    const result: any = await getPlasticSourceList({ traceId: state.id });
    if (result.data.code == 0) {
      const { initMap } = useMap(state);
      const tempData = result.data.data;
      // 将几种数据增加一个类型进去，方便循环时做区分
      // vr数据类型
      let vrList = tempData.vrs.map((item: any) => {
        item.types = "vr";
        return item;
      });
      // 地理位置类型
      let locationList = tempData.locations.map((item: any) => {
        item.types = "location";

        return item;
      });
      // 视频监控类型
      let monitoringsList = tempData.monitorings.map((item: any) => {
        item.types = "moni";
        return item;
      });

      // 组装气象数据
      for (let i = 0; i < tempData.weather.length; i++) {
        let weather = tempData.weather[i];
        let tempWeather = [
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 82@2x.png",
            value: weather.airTem ? weather.airTem + "℃" : "暂无",
            text: "空气温度",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 84@2x.png",
            value: weather.airHum ? weather.airHum + "%" : "暂无",
            text: "空气湿度",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 85@2x.png",
            value: weather.beamP ? weather.beamP + "lux" : "暂无",
            text: "光照强度",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 83@2x.png",
            value: weather.soilTem ? weather.soilTem + "℃" : "暂无",
            text: "土壤温度",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 86@2x.png",
            value: weather.soilHum ? weather.soilHum + "%" : "暂无",
            text: "土壤湿度",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 91@2x.png",
            value: weather.sunshine ? weather.sunshine + "min" : "暂无",
            text: "日照时长",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 90@2x.png",
            value: weather.moisture ? weather.moisture + "mm" : "暂无",
            text: "日降雨量",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 89@2x.png",
            value: weather.ph ? weather.ph : "暂无",
            text: "土壤PH",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 88@2x.png",
            value: weather.wind ? weather.wind + "m/s" : "暂无",
            text: "风速",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 87@2x.png",
            value: weather.co2 ? weather.co2 + "ppm" : "暂无",
            text: "二氧化碳",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 92@2x.png",
            value: weather.ec ? weather.ec + "ms/cm" : "暂无",
            text: "土壤EC",
          },
          {
            url: "https://qnui.xfarmer.com/xfarmer-ui/trace/组 93@2x.png",
            value: weather.windDirection ? weather.windDirection : "暂无",
            text: "风向",
          },
        ];
        //   手动增加一个showdata属性用于控制数据显示多少条，是否展开
        state.weatherList.push({
          showData: 6,
          datas: tempWeather,
          name: weather.name,
          sortType: tempData.weather[i].sortType,
          sort: tempData.weather[i].sort,
        });
      }
      state.countList = [
        ...vrList,
        ...monitoringsList,
        ...locationList,
        ...state.weatherList,
      ];
      state.countList = state.countList.sort((a: any, b: any) => {
        if (a.sort > b.sort) {
          return 1;
        } else if (a.sort < b.sort) {
          return -1;
        } else {
          return 0;
        }
      });
      state.countList.forEach((item: any) => {
        // 延时1.5秒后 等dom彻底加载完后，在开始初始化地图，地图中的dom容器id是根据数据的id区分的，因此需要传入对应id
        if (item.types == "location") {
          nextTick(() => {
            let timer = setTimeout(() => {
              clearTimeout(timer);
              initMap(item);
            }, 1500);
          });
        }
      });
    }
  };
  return {
    getPlasticSourceData,
  };
};
// 存放地图相关的hook
const useMap = (state: StateType) => {
  // 初始化地图
  const initMap = (item: any) => {
    if (document.getElementById("mapContainer" + item.id)) {
      // 设置地图中心点
      let centerLoc = new TencentMap.LatLng(Number(item.lat), Number(item.lng));
      // 设置容器
      let map = new TencentMap.Map("mapContainer" + item.id, {
        zoom: 17, //设置地图缩放级别
        center: centerLoc, //设置地图中心点坐标
      });
      map.removeControl(TencentMap.constants.DEFAULT_CONTROL_ID.ZOOM);
      map.removeControl(TencentMap.constants.DEFAULT_CONTROL_ID.ROTATION);
      map.removeControl(TencentMap.constants.DEFAULT_CONTROL_ID.LOGO);
      map.removeControl(TencentMap.constants.DEFAULT_CONTROL_ID.FLOOR);
      map.removeControl(TencentMap.constants.DEFAULT_CONTROL_ID.SCALE);
      //  map.removeControl(control);
      // // 在位置上添加信息
      new TencentMap.InfoWindow({
        map,
        position: centerLoc,
        enableCustom: true,
        content: `<div style="min-width: 3rem;padding: 0.625rem;background:yellow;display:flex;font-size: 14px;
        border-radius:10px;
        position:relative;
        "><span>${item.locationName}</span>
        <div style="width: 0rem;height:0rem;position:absolute;bottom:-0.69rem;left:0;right:0;margin:0 auto;border-top: 0.7rem solid yellow;border-left: 0.6rem solid transparent; border-right: 0.6rem solid transparent;"></div>
        </div>`,
      });
      map.setMinZoom(15);
      map.setMaxZoom(18);
      map.setZoom(16);
      if (/(Android)/i.test(navigator.userAgent)) {
        map.setBaseMap({ type: "satellite" });
      } else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        map.setBaseMap({ type: "vector" });
      }
    }
  };

  return {
    initMap,
  };
};
// 事件相关hook
const useEvent = (states?: StateType, router?: Router) => {
  const onClickMap = (item: any) => {
    router &&
      router.push({
        path: "/showMap",
        query: {
          latitude: item.lat,
          longitude: item.lng,
          title: item.locationName,
        },
      });
  };
  const onClickLand = (item: any) => {
    if (item.vrType == 1) {
      window.open(item.vrUrl);
    } else {
      router &&
        router.push({
          path: `/vr`,
          query: {
            vrUrl: item.titleImg[0].url,
          },
        });
    }
  };
  // 滑动到底部时执行
  const onBottom = () => {
    throttle.search(null);
  };
  const onShowVideo = (item: any) => {
    window.open(item.monitoringUrl);
  };
  const onClickMore = (item: any) => {
    item.showData = item.showData == 6 ? 99 : 6;
  };

  return {
    onClickMore,
    onShowVideo,
    onClickLand,
    onBottom,
    onClickMap,
  };
};
